__webpack_require__.p = "%STATIC_ASSET_DOMAIN%/";